var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThunder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "100px",
    width: "70px",
    viewBox: "100 0 311.999 511.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M318.726,199.927h86.463c9.936,0,15.318,11.632,8.886,19.206L174.712,500.979  c-5.824,6.858-16.965,1.554-15.316-7.29l33.882-181.615H106.81c-9.936,0-15.318-11.632-8.886-19.206L337.288,11.02  c5.823-6.858,16.965-1.554,15.316,7.29L318.726,199.927z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThunder);
export default __webpack_public_path__ + "static/media/thunder.e0652c351e9057e01818b858f17afaec.svg";
export { ForwardRef as ReactComponent };